import React from 'react';
import { components } from 'react-select';
import useHover from 'react-use/lib/useHover';
import { Icon } from '../../../Icon/Icon';

const element = (hovered: boolean) => (
  <Icon
    className={`fa${hovered ? 's' : 'r'} fa-times-circle`}
    color="neutral.500"
    css="cursor: pointer"
  />
);

export const ClearIndicator = props => {
  const [icon] = useHover(element);

  return <components.ClearIndicator {...props}>{icon}</components.ClearIndicator>;
};
